import React from 'react'

type Props = {
  line1?: string
  line2?: string
  className?: string
}

/** Nhãn chi nhánh tối đa 2 dòng: dòng 1 = dự án, dòng 2 = chi nhánh. */
const ChiNhanhBranchLabel: React.FC<Props> = ({ line1 = '', line2 = '', className }) => {
  const l1 = line1.trim()
  const l2 = line2.trim()
  if (!l1 && !l2) return null

  const rootClass = ['chi-nhanh-branch-label', className].filter(Boolean).join(' ')

  return (
    <span className={rootClass}>
      {l1 ? (
        <span className="chi-nhanh-branch-label__line1" title={l1}>
          {l1}
        </span>
      ) : null}
      {l2 ? (
        <span className="chi-nhanh-branch-label__line2" title={l2}>
          {l2}
        </span>
      ) : null}
    </span>
  )
}

export default ChiNhanhBranchLabel
